import React from "react";
import { NavDropdown, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { usePresentation, useAdsByCustomer, useMetadata } from "hooks/query";
import { useParams } from "react-router";
import CenterSpinner from "components/CenterSpinner";
import "./Header.css";

export default function StudentjobbButtons() {
    const metadataQuery= useMetadata();
    const adsByCustomer = useAdsByCustomer();
    console.log("FROM ADSBYCUSTOMER", adsByCustomer);
    const adTypes = [
        { className: "button-trainee", adType: "1", title: "Traineeprogram" },
        { className: "button-intnernship", adType: "2", title: "Internship" },
        { className: "button-exam", adType: "3", title: "Examensarbete" },
        { className: "button-jobb", adType: "4", title: "Jobb" },
    ];
    
    return (
        <>
            {adsByCustomer.isLoading || metadataQuery.isLoading ? (
                <CenterSpinner />
            ) : (
                
                <Row className="mt-5 justify">
                    {adTypes.map((at) => {
                        return (
                            <>
                            {adsByCustomer.data.$values.map((ads) => {
                                    return (
                                        <>
                                            {ads.adType?.toLowerCase() == at.title.toLowerCase() && (
                            <Col lg={3} xs={12}>
                                
                                                <NavDropdown 
                                                    title={at.title}
                                                    id="basic-nav-dropdown"                                                   
                                                    className={"button-rounded text-color center " + at.className}
                                                >
                                                    {adsByCustomer.data.$values.map((ads) => {
                                                        return (
                                                            <>
                                                                {ads.adType?.toLowerCase() == at.title.toLowerCase() && (
                                                                    <NavDropdown.Item className="text-color center">
                                                                        <Link 
                                                                            to={{
                                                                                pathname: `/utbildning/${ads.slug}`,
                                                                            }}
                                                                        >
                                                                            {ads.title}
                                                                        </Link>
                                                                    </NavDropdown.Item>
                                                                )}
                                                            </>
                                                        );
                                                    })}
                                                </NavDropdown>
                                           </Col> )}
                                        </>
                                    );
                                })}
                            
                       </> );
                    })}
                </Row>
            )}
        </>
    );
}
